import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Autocomplete from "@material-ui/lab/Autocomplete";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
//cookies
import {get_cookies} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));



const JCPortalUpgradeAccountPackageSales = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [transaction_no, setTransaction_no] = useState('');
	const [package_code, setPackage_code] = useState('');

	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));
	const [downloadFlag, setDownloadFlag] = useState(false);
	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	const dataFilter = async () => {
		setDataLoaded(false);
        await axios.get(
			process.env.REACT_APP_API_URL+'upgrade_details_table', {
            params:{
				// jc_u_idno:DAVAOHQ
				// date_from:2015-01-01
				// date_to:2021-01-01
				jc_u_idno: useridNo,  
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
            }
        }).then((res)=>{
			setPosts(res.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		})
		setDataLoaded(true);
    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const columns = [
		{
			name: "date",
			label: "Date",
		},
		{
			name: "idno",
			label: "ID No",
		},
		{
			name: "transaction_no",
			label: "TRANSACTION NO",
		},
		{
			name: "orig_atype",
			label: "ORIGINAL ATYPE",
		},
		{
			name: "shipping_status",
			label: "Shipping Status",			
		},
		{
			name: "action",
			label: "Action",
			options: {
				download: false, //exclude this column in csv export
				customBodyRenderLite: (dataIndex) => {
					let isreleased =  posts[dataIndex].isreleased;
					let waybill_no =  posts[dataIndex].waybill_no;
					let isdelivered =  posts[dataIndex].isdelivered;
					let transaction_no =  posts[dataIndex].transaction_no;
					if(isreleased===0){
						return(
							<Grid container spacing={1}>
								<Grid item xs={12} sm={6} md={12} lg={12} xl={12}>
									<NavLink to={"/sales/jcportalupgrade-view/"+transaction_no+"/view"}>
										<Button variant="contained" color="primary">
											View
										</Button>	
									</NavLink> 
								</Grid>
								<Grid item xs={12} sm={6} md={12} lg={12} xl={12}>
									<NavLink to={"/sales/jcportalupgrade-view/"+transaction_no+"/release"}>
										<Button variant="contained" color="primary"> 
											Release
										</Button>	
									</NavLink> 	
								</Grid>
							</Grid>)
					}else{
						if(waybill_no === ""){
							return(
								<Grid container spacing={1}>
									<Grid item xs={12} sm={6} md={12} lg={12} xl={12}>
										<NavLink to={"/sales/jcportalupgrade-view/"+transaction_no+"/view"}>
											<Button variant="contained" color="primary">
												View
											</Button>	
										</NavLink> 
									</Grid>
									<Grid item xs={12} sm={6} md={12} lg={12} xl={12}>
										<NavLink to={"/sales/jcportalupgrade-view/"+transaction_no+"/waybill"}>
											<Button variant="contained" color="primary"> 
												Enter Waybill
											</Button>	
										</NavLink> 	
									</Grid>
								</Grid>)	
						}else{
							if(isdelivered === 1){
								return(
									<Grid container spacing={1}>
										<Grid item xs={12} sm={6} md={12} lg={12} xl={12}>
											<NavLink to={"/sales/jcportalupgrade-view/"+transaction_no+"/view"}>
												<Button variant="contained" color="primary">
													Print
												</Button>	
											</NavLink> 
										</Grid>
									</Grid>)
							}else{
								return(
									<Grid container spacing={1}>
										<Grid item xs={12} sm={6} md={12} lg={12} xl={12}>
											<NavLink to={"/sales/jcportalupgrade-view/"+transaction_no+"/view"}>
												<Button variant="contained" color="primary">
													View
												</Button>	
											</NavLink> 
										</Grid>
										<Grid item xs={12} sm={6} md={12} lg={12} xl={12}>
											<NavLink to={"/sales/jcportalupgrade-view/"+transaction_no+"/deliver"}>
												<Button variant="contained" color="primary"> 
													Confirm Delivery
												</Button>	
											</NavLink> 	
										</Grid>
									</Grid>)	
							}
						}
					}
				},
			},
	 	}
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		download: false,  //add this
		print: false,
		viewColumns:false, //add this
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		downloadOptions: {
			filename : 'JcPortalUpgradeAccountPackageSales.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<NavLink to={"/sales"}><h2 style={{color:"black"}}>Sales</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>JC Portal Upgrade Account Package Sales</h2>
			</div>
			<div className="page-container">
				<div style={style}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
									style={{marginTop:"1rem"}}
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
                            <Grid item xs={1} lg={1} xl={1}>
                                <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                            </Grid>
                        </Grid>        
                    </div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					// <MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
									<div className="table-subtitle">Table</div>
									<div className="table-title">
									JC Portal Upgrade Account Package Sales
									</div>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
				//   </MuiThemeProvider>
				)}
			</div>
		</div>
	);
};

export default JCPortalUpgradeAccountPackageSales;